/* jslint node: true */

"use strict";
var basic = require("./utils/basic"),
  formatMessage = basic.formatMessage,
  core = {
    generalMessages: {
      errors: {
        LOCALE_INVALID: "The locale is invalid",
        METADATA_REQUIRED: "The metadata is required",
        METADATA_INVALID: "The metadata is invalid"
      },
      warnings: {}
    },

    addError: function addError(obj, domain, msgName, details) {
      if (obj) {
        addMessage(obj, domain, "errors", msgName, details);
      }
    },

    addWarning: function addWarning(obj, domain, msgName, details) {
      if (obj) {
        addMessage(obj, domain, "warnings", msgName, details);
      }
    },

    // TypeError is thrown whenever the type of an object, specially a function parameter, does not match the expected type.
    // For example, when a function requires a parameter to be of type string, but a number type is passed.
    throwTypeError: function throwTypeError(message) {
      throw new TypeError(message);
    },

    // ReferenceError represents an error when a non-existent variable is referenced.
    // For example. when an object is null or undefined and needs to be dereferenced.
    throwReferenceError: function throwReferenceError(message) {
      throw new ReferenceError(message);
    },

    // Any general type of error, not specific as TypeError or ReferenceError.
    throwError: function throwError(message) {
      // TODO code can be first parameter, but need to change all the usages
      throw new Error(message);
    },

    isLatin: function isLatin(string) {
      if (!string) {
        return true;
      }
      for (var i = 0; i < string.length; i++) {
        if (string.charCodeAt(i) > 0x24f) {
          return false;
        }
      }
      return true;
    },

    getCountry: function(handler, countryCode) {
      var countryAliasMapping = {
        // TODO reuse
        C2: "CN",
        UK: "GB"
      };
      return countryAliasMapping[countryCode] || countryCode || handler.country;
    },

    languageDefaultScript: function languageDefaultScript(language) {
      // TODO var languageScripts = getMeta('languageScripts');
      return (
        languageScripts &&
        languageScripts.language &&
        languageScripts.language[language] &&
        languageScripts.language[language].languageScript
      );
    }
  };

// simple response helper to resolve error names into descriptive messages
function addMessage(obj, domain, severity, msgName, detail) {
  if (!obj[severity]) {
    obj[severity] = [];
  }
  var error = {
    name: msgName,
    message:
      (domain && domain[severity][msgName]) ||
      core.generalMessages[severity][msgName]
  };
  if (detail) {
    if (typeof detail === "object") {
      // by convention if there is a property message then it will be messageFormat
      // taking msgValues param with the values to be replaced {codePoint: 11234}
      if (detail.hasOwnProperty("message")) {
        error.message = formatMessage(error.message, detail.msgValues);
        error.detail = detail.field;
      } else {
        error.detail = detail;
      }
    } else {
      error.detail = detail;
    }
  }
  obj[severity].push(error);
}

// TODO remove this
var languageScripts = {
  language: {
    "en-US": {
      languageScript: "Latn"
    },
    "es-MX": {
      languageScript: "Latn"
    },
    fr: {
      languageScript: "Latn"
    },
    "zh-Hans-CN": {
      languageScript: "Hans"
    },
    "ar-EG": {
      languageScript: "Arab"
    },
    "de-DE": {
      languageScript: "Latn"
    },
    "en-AU": {
      languageScript: "Latn"
    },
    "fr-FR": {
      languageScript: "Latn"
    },
    "nl-NL": {
      languageScript: "Latn"
    },
    "pt-BR": {
      languageScript: "Latn"
    },
    "fr-CA": {
      languageScript: "Latn"
    },
    "da-DK": {
      languageScript: "Latn"
    },
    "ru-RU": {
      languageScript: "Cyrl"
    },
    "es-ES": {
      languageScript: "Latn"
    },
    "en-GB": {
      languageScript: "Latn"
    },
    "zh-Hant-HK": {
      languageScript: "Hant"
    },
    "id-ID": {
      languageScript: "Latn"
    },
    "he-IL": {
      languageScript: "Hebr"
    },
    "it-IT": {
      languageScript: "Latn"
    },
    "ja-JP": {
      languageScript: "Jpan"
    },
    "ko-KR": {
      languageScript: "Kore"
    },
    "nb-NO": {
      languageScript: "Latn"
    },
    "pl-PL": {
      languageScript: "Latn"
    },
    "pt-PT": {
      languageScript: "Latn"
    },
    "sv-SE": {
      languageScript: "Latn"
    },
    "th-TH": {
      languageScript: "Thai"
    },
    "tr-TR": {
      languageScript: "Latn"
    },
    "zh-Hant-TW": {
      languageScript: "Hant"
    }
  }
};

module.exports = core;



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/griffin-paypal/lib/client/core.js
// module id = 340
// module chunks = 5 6 7 8 9 10 11